import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { initI18n } from './lib/i18n.js';
import { queryClient } from './lib/queryClient.js';
import { App } from './App.js';
import './index.css';

const i18n = initI18n();
document.documentElement.lang = i18n.language;

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root container not found');

createRoot(rootEl).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
